export class AcceptLegalTerms {
  public static readonly type = '[App] Accept Legal Terms';
}

export class AcceptPrivacyPolicy {
  public static readonly type = '[App] Accept Privacy Policy';
}

export class AcceptLegalTermsAndPrivacyPolicy {
  public static readonly type = '[App] Accept Legal Terms and Privacy Policy';
}

export class FetchLegalTermsAndPrivacyPolicyUpdatedDate {
  public static readonly type = '[App] Fetch Legal Terms and Privacy Policy Updated Date';
  constructor(public payload?: boolean) {}
}

export class FetchLegalTermsAndPrivacyPolicyUpdatedDateSuccess {
  public static readonly type = '[App] Fetch Legal Terms and Privacy Policy Updated Date Success';
  constructor(public payload: { legalTermsDate: string; privacyPolicyDate: string; redirect: boolean }) {}
}
